import { isNil } from 'lodash';
import { PublicCompanyAdjustmentStatus } from 'api/models/PublicCompanyAdjustmentStatus';
import { compKeyMap } from './constants';

const checkAsOfComps = (asOfValues: PublicCompanyAdjustmentStatus[]) => {
  /* True once any as-of value has been saved. Only a never-fetched snapshot is refetched on open,
  so saved values are never replaced without the user asking */
  const metricKeys = Object.keys(compKeyMap) as (keyof PublicCompanyAdjustmentStatus)[];
  return asOfValues.some(asOfValue => metricKeys.some(key => !isNil(asOfValue[key])));
};

export default checkAsOfComps;
